(() => {
  /* Move the fixed bars to <body> so theme sections/products can never
     cover them (Horizon sections create their own layers). */
  ['nv-header','nv-bottom','nv-wa','nv-menu']
    .forEach(id => { const el = document.getElementById(id); if (el && el.parentNode !== document.body) document.body.appendChild(el); });
})();

(() => {
  /* Menu drawer — runs on EVERY page, homepage or not */
  const header = document.getElementById('nv-header');
  const menu = document.getElementById('nv-menu');
  if (!header || !menu || menu.dataset.menuReady === 'true') return;
  menu.dataset.menuReady = 'true';
  const menuButton = header.querySelector('.nv-header__menu');
  const menuClose = menu.querySelector('.nv-menu-drawer__close');
  function setMenu(open) {
    menu.classList.toggle('is-open', open);
    menu.setAttribute('aria-hidden', String(!open));
    if (menuButton) menuButton.setAttribute('aria-expanded', String(open));
  }
  if (menuButton) menuButton.addEventListener('click', () => setMenu(true));
  if (menuClose) menuClose.addEventListener('click', () => setMenu(false));
  menu.addEventListener('click', event => {
    if (event.target.closest('a')) setMenu(false);
  });
})();

(() => {
  /* Homepage push-panel slider — only runs where #nv-push exists (homepage) */
  const root = document.getElementById('nv-push');
  if (!root || root.dataset.pushReady === 'true') return;
  root.dataset.pushReady = 'true';
  const panels = Array.from(root.querySelectorAll('.nv-push__panel'));
  const dotsBox = root.querySelector('.nv-push__dots');
  const header = document.getElementById('nv-header');
  if (!panels.length) return;

  const isMobile = () => matchMedia('(max-width: 749px)').matches;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  let active = 0, animating = false, wheelTotal = 0, wheelReset, lastSwipe = 0;
  let touchStartY = null, touchStartX = null, touchLastY = null, touchStartTime = 0;
  const WHEEL_TRIGGER = 28;
  const SWIPE_DISTANCE = 30;   /* px a finger must travel for a swipe */
  const SWIPE_FLICK = 0.35;    /* px per ms — a quick flick also counts */

  /* Slide speed: a bit faster on phones so it never feels "stuck". */
  const speed = () => reduced ? 1 : (isMobile() ? 550 : 850);
  const applySpeed = () => root.style.setProperty('--push-speed', speed() + 'ms');

  /* Mobile: size the slider to the REAL visible screen (minus the 72px header).
     Phones change height when the address bar hides/shows; CSS 100svh does not
     follow that, which made the old code think the slider was "not on screen"
     and ignore swipes. */
  function fitHeight() {
    if (isMobile()) root.style.height = (window.innerHeight - 72) + 'px';
    else root.style.height = '';
    applySpeed();
  }
  fitHeight();
  window.addEventListener('resize', fitHeight);
  window.addEventListener('orientationchange', () => setTimeout(fitHeight, 250));

  panels.forEach((panel, index) => {
    panel.style.zIndex = String(index + 1);
    panel.classList.toggle('is-revealed', index === 0);
    const dot = document.createElement('span');
    dot.className = 'nv-push__dot' + (index === 0 ? ' is-active' : '');
    dotsBox.appendChild(dot);
  });
  const dots = Array.from(dotsBox.children);
  const lastIndex = panels.length - 1;
  const footerPanel = panels[lastIndex].tagName === 'A' ? null : panels[lastIndex];

  /* Desktop only: the wheel takes over only when the slider fills the window. */
  function fullyEngaged() {
    const rect = root.getBoundingClientRect();
    const offset = parseFloat(getComputedStyle(root).getPropertyValue('--header-offset')) || 0;
    return rect.top <= offset + 2 && rect.bottom >= innerHeight - 2;
  }

  function update() {
    dots.forEach((dot, i) => dot.classList.toggle('is-active', i === active));
    /* Slide 1: black; slides 2–4: white; slides 5–7: black. */
    if (header) header.classList.toggle('is-light', active >= 1 && active <= 3);
    /* On the footer slide let the footer content scroll normally. */
    root.classList.toggle('is-on-footer', !!footerPanel && active === lastIndex);
  }
  update();

  function goTo(index) {
    if (animating || index < 0 || index > lastIndex || index === active) return false;
    animating = true;
    if (index > active) for (let i = 0; i <= index; i++) panels[i].classList.add('is-revealed');
    else for (let i = lastIndex; i > index; i--) panels[i].classList.remove('is-revealed');
    active = index; update();
    window.setTimeout(() => { animating = false; }, speed() + 30);
    return true;
  }

  /* ---------- Desktop: mouse wheel / trackpad ---------- */
  root.addEventListener('wheel', event => {
    if (isMobile() || !fullyEngaged()) return;
    const direction = event.deltaY > 0 ? 1 : -1;
    const atBoundary = (direction < 0 && active === 0) || (direction > 0 && active === lastIndex);
    if (atBoundary && !animating) { wheelTotal = 0; return; }
    event.preventDefault();
    if (animating || Math.abs(event.deltaY) < .1) return;
    clearTimeout(wheelReset); wheelTotal += event.deltaY;
    wheelReset = setTimeout(() => { wheelTotal = 0; }, 120);
    if (Math.abs(wheelTotal) >= WHEEL_TRIGGER) {
      const step = wheelTotal > 0 ? 1 : -1; wheelTotal = 0; goTo(active + step);
    }
  }, { passive: false });

  /* ---------- Mobile: swipe up / down ---------- */
  root.addEventListener('touchstart', event => {
    const t = event.touches[0];
    touchStartY = touchLastY = t.clientY; touchStartX = t.clientX; touchStartTime = Date.now();
  }, { passive: true });

  root.addEventListener('touchmove', event => {
    if (touchStartY === null) return;
    touchLastY = event.touches[0].clientY;
    /* On the footer slide, let its own content scroll — unless the user is at the
       top of the footer and pulls down (that goes back to the previous slide). */
    if (footerPanel && active === lastIndex) {
      const pullingDown = touchLastY > touchStartY;
      if (!(pullingDown && footerPanel.scrollTop <= 0)) return;
    }
    if (event.cancelable) event.preventDefault();   /* the slider owns this gesture */
  }, { passive: false });

  root.addEventListener('touchend', event => {
    if (touchStartY === null) return;
    const t = event.changedTouches[0];
    const dy = touchStartY - t.clientY;
    const dx = touchStartX - t.clientX;
    const ms = Math.max(1, Date.now() - touchStartTime);
    touchStartY = touchLastY = touchStartX = null;
    if (Math.abs(dx) > Math.abs(dy)) return;                 /* sideways move: ignore */
    const isSwipe = Math.abs(dy) >= SWIPE_DISTANCE || (Math.abs(dy) >= 12 && Math.abs(dy) / ms >= SWIPE_FLICK);
    if (!isSwipe) return;                                    /* a tap: let the click open the link */
    lastSwipe = Date.now();
    if (footerPanel && active === lastIndex && dy > 0) return;   /* footer: scrolling its content */
    if (footerPanel && active === lastIndex && dy < 0 && footerPanel.scrollTop > 0) return;
    goTo(active + (dy > 0 ? 1 : -1));
  }, { passive: true });

  root.addEventListener('touchcancel', () => { touchStartY = touchLastY = touchStartX = null; }, { passive: true });

  /* ---------- Tap / click opens the collection on screen ---------- */
  root.addEventListener('click', event => {
    const panel = panels[active];
    if (!panel || panel.tagName !== 'A') return;            /* footer slide: normal clicks */
    event.preventDefault();
    if (animating || Date.now() - lastSwipe < 400) return;
    window.location.href = panel.href;
  });

  /* ---------- Keyboard (desktop) ---------- */
  window.addEventListener('keydown', event => {
    if (isMobile() || !fullyEngaged() || animating) return;
    const down = event.key === 'ArrowDown' || event.key === 'PageDown';
    const up = event.key === 'ArrowUp' || event.key === 'PageUp';
    if (!down && !up) return;
    const next = active + (down ? 1 : -1);
    if (next < 0 || next > lastIndex) return;
    event.preventDefault(); goTo(next);
  });
})();

(() => {
  /* Live cart counter — updates the header + mobile bottom-bar cart numbers
     the moment a product is added/changed/removed (no page refresh needed). */
  if (window.__nvCartCounter) return;
  window.__nvCartCounter = true;

  function setCount(n) {
    document.querySelectorAll('.nv-header__cart-count').forEach(el => { el.textContent = n; });
    document.querySelectorAll('#nv-bottom .nv-badge').forEach(el => { el.textContent = n; });
    const iconLink = document.querySelector('#nv-header .nv-header__icon-cart');
    if (iconLink) {
      let badge = iconLink.querySelector('.nv-badge');
      if (n > 0) {
        if (!badge) { badge = document.createElement('span'); badge.className = 'nv-badge'; iconLink.appendChild(badge); }
        badge.textContent = n;
      } else if (badge) badge.remove();
    }
  }

  let timer;
  function refresh() {
    clearTimeout(timer);
    timer = setTimeout(() => {
      fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(r => r.json()).then(cart => setCount(cart.item_count)).catch(() => {});
    }, 60);
  }

  const isCartRequest = url => /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(String(url || ''));

  /* Watch the theme's own add-to-cart requests (fetch) */
  const nativeFetch = window.fetch;
  window.fetch = function (input, init) {
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    const result = nativeFetch.apply(this, arguments);
    if (isCartRequest(url)) result.then(refresh, refresh);
    return result;
  };

  /* ...and older-style requests (XMLHttpRequest), used by some apps */
  const nativeOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (isCartRequest(url)) this.addEventListener('loadend', refresh);
    return nativeOpen.apply(this, arguments);
  };

  /* Theme / app cart events, and pages restored from the back button */
  ['cart:update', 'cart:updated', 'cart:refresh', 'cart:change'].forEach(name => document.addEventListener(name, refresh));
  window.addEventListener('pageshow', event => { if (event.persisted) refresh(); });
})();

(() => {
  /* Product page — Stitched / Unstitched:
     • "Complete Suit" never shows as a size button.
     • Picking "Unstitched" hides the whole Size row; Shopify selects
       "Complete Suit" in the background so the price + Add to cart update. */
  if (window.__nvUnstitched) return;
  window.__nvUnstitched = true;

  const isSizeGroup = group => {
    const label = group.querySelector('legend, .variant-option__name, [class*="option-name"], label');
    const name = (label ? label.textContent : '').trim().toLowerCase();
    return name.startsWith('size') || !!group.querySelector('input[value="Complete Suit"], option[value="Complete Suit"]');
  };

  function unstitchedSelected(picker) {
    const radio = picker.querySelector('input[type="radio"][value="Unstitched"]');
    if (radio) return radio.checked;
    return Array.from(picker.querySelectorAll('select')).some(s => s.value === 'Unstitched');
  }

  function hideCompleteSuit(group) {
    group.querySelectorAll('input[value="Complete Suit"]').forEach(input => {
      input.style.display = 'none';
      const label = (input.id && group.querySelector('label[for="' + CSS.escape(input.id) + '"]')) || input.closest('label');
      if (label) label.style.display = 'none';
    });
    group.querySelectorAll('option[value="Complete Suit"]').forEach(o => { o.hidden = true; o.disabled = true; });
  }

  let busy = false;
  function apply() {
    if (busy) return;
    busy = true;
    document.querySelectorAll('variant-picker, .variant-picker, product-form, form[action*="/cart/add"]').forEach(picker => {
      const unstitched = unstitchedSelected(picker);
      picker.querySelectorAll('fieldset, .variant-option, .product-form__input').forEach(group => {
        if (!isSizeGroup(group)) return;
        hideCompleteSuit(group);
        group.style.display = unstitched ? 'none' : '';
      });
    });
    busy = false;
  }

  /* Before the theme reads the choice, pick the matching size in the background:
     Unstitched -> "Complete Suit"; Stitched -> first real size. Runs in the capture
     phase, so the theme then finds a variant that exists (no "Unavailable"). */
  document.addEventListener('change', event => {
    const t = event.target;
    if (!t || !t.closest) return;
    const picker = t.closest('variant-picker, .variant-picker, product-form, form[action*="/cart/add"]') || document;
    const val = t.value;
    if (val !== 'Unstitched' && val !== 'Stitched') return;
    const radios = Array.from(picker.querySelectorAll('input[type="radio"]'));
    const complete = radios.find(r => r.value === 'Complete Suit');
    if (complete) {
      if (val === 'Unstitched') complete.checked = true;
      else if (complete.checked) {
        const size = radios.find(r => /^(XS|S|M|L|XL|XXL)$/.test(r.value) && !r.disabled) || radios.find(r => /^(XS|S|M|L|XL|XXL)$/.test(r.value));
        if (size) size.checked = true;
      }
    }
    picker.querySelectorAll('select').forEach(s => {
      const opts = Array.from(s.options).map(o => o.value);
      if (!opts.includes('Complete Suit')) return;
      if (val === 'Unstitched') s.value = 'Complete Suit';
      else if (s.value === 'Complete Suit') s.value = opts.find(v => v !== 'Complete Suit') || s.value;
    });
  }, true);

  document.addEventListener('change', () => setTimeout(apply, 0), true);
  new MutationObserver(() => requestAnimationFrame(apply))
    .observe(document.documentElement, { childList: true, subtree: true });
  apply();
})();

(() => {
  /* Product page: "SAVE x%" badge next to the price + trust badges under Buy buttons */
  if (window.__nvProductUI) return;
  window.__nvProductUI = true;

  const num = el => el ? parseFloat(el.textContent.replace(/[^0-9.]/g, '')) || 0 : 0;

  function saveBadge() {
    document.querySelectorAll('product-price').forEach(box => {
      const cmp = box.querySelector('.compare-at-price, s, del, .price__compare, .price-item--compare');
      const cur = Array.from(box.querySelectorAll('.price, .price__current, .price-item--sale, .price-item--regular, span'))
        .find(el => el !== cmp && !cmp?.contains(el) && !el.closest('s, del, .nv-save-badge') && /\d/.test(el.textContent));
      let badge = box.querySelector('.nv-save-badge');
      const a = num(cur), b = num(cmp);
      if (b > a && a > 0) {
        const pct = Math.round((1 - a / b) * 100);
        if (!badge) { badge = document.createElement('span'); badge.className = 'nv-save-badge'; box.appendChild(badge); }
        const txt = 'SAVE ' + pct + '%';
        if (badge.textContent !== txt) badge.textContent = txt;
      } else if (badge) badge.remove();
    });
  }

  const ICON = {
    truck: '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"><path d="M2 6h11v10H2zM13 9h4.5L21 12.5V16h-8z"/><circle cx="6" cy="17.5" r="1.8"/><circle cx="17" cy="17.5" r="1.8"/></svg>',
    cash: '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"><rect x="2" y="6" width="20" height="12" rx="2"/><circle cx="12" cy="12" r="2.5"/><path d="M6 9v.01M18 15v.01"/></svg>',
    swap: '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M4 7h13l-3-3M20 17H7l3 3"/></svg>',
    needle: '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"><path d="M20 4 6 18M17 4h3v3M4 20l2-2"/><path d="M9 9c-3 0-5 2-5 4"/></svg>'
  };

  function trust() {
    const anchor = document.querySelector('.shopify-payment-button, .product-form__buttons, add-to-cart-component');
    if (!anchor || document.querySelector('.nv-trust')) return;
    const ul = document.createElement('ul');
    ul.className = 'nv-trust';
    ul.innerHTML =
      `<li>${ICON.cash}<span><strong>Cash on Delivery</strong>Pay when it arrives</span></li>
       <li>${ICON.truck}<span><strong>Nationwide delivery</strong>2–5 working days</span></li>
       <li>${ICON.swap}<span><strong>Easy exchange</strong>Within 3 days</span></li>
       <li>${ICON.needle}<span><strong>Stitched or unstitched</strong>Your choice</span></li>`;
    (anchor.closest('form') || anchor).insertAdjacentElement('afterend', ul);
  }

  function run() { if (document.querySelector('product-price, variant-picker')) { saveBadge(); trust(); } }
  let t;
  new MutationObserver(() => { clearTimeout(t); t = setTimeout(run, 50); })
    .observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  run();
})();